// Actions
import { MainActions, MainActionTypes } from './main.actions';

// Models
import { MainState } from './main.state';
import { SearchFeatureChecksHelper } from '../../../shared/models/b2b/searchFeatureChecks';
import * as _ from 'lodash';

const defaultState: MainState = {
    loading: true,
    loadingReplacementorders: true,
    error: '',
    orders: [],
    invoices: [],
    brands: [],
    allBrands: [],
    replacementOrders: [],
    featureOptions: {},
    menuItem: undefined,
    banners: undefined,
    preLogin: null,
    forceSearchTypeFlag: undefined,
    searchFeatureChecks: SearchFeatureChecksHelper.default(),
};

export type Action = MainActions;

export function MainReducer(state = defaultState, action: any) {
    // console.log(state, action);
    switch (action.type) {
        case MainActionTypes.DO_GET_INFO_INVOICES:
            return {
                ...state,
                loading: true,
                error: '',
                invoices: [],
            };

        case MainActionTypes.DO_GET_INFO_INVOICES_OK:
            return {
                ...state,
                loading: false,
                invoices: action.payload.value,
            };

        case MainActionTypes.DO_GET_INFO_INVOICES_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                invoices: [],
            };

        case MainActionTypes.DO_GET_INFO_ORDERS:
            return {
                ...state,
                loading: true,
                error: '',
                orders: [],
            };

        case MainActionTypes.DO_GET_INFO_ORDERS_OK:
            return {
                ...state,
                loading: false,
                orders: action.payload.value,
            };

        case MainActionTypes.DO_GET_INFO_ORDERS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                orders: [],
            };

        case MainActionTypes.DO_GET_BRANDS:
            return {
                ...state,
                loading: true,
                error: '',
                brands: [],
            };

        case MainActionTypes.DO_GET_BRANDS_OK:
            return {
                ...state,
                loading: false,
                brands: action.payload,
            };

        case MainActionTypes.DO_GET_BRANDS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                brands: [],
            };

        case MainActionTypes.DO_GET_ALLBRANDS:
            return {
                ...state,
                loading: true,
                error: '',
                allBrands: [],
            };

        case MainActionTypes.DO_GET_ALLBRANDS_OK:
            return {
                ...state,
                loading: false,
                allBrands: action.payload,
            };

        case MainActionTypes.DO_GET_ALLBRANDS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                allBrands: [],
            };

        case MainActionTypes.DO_GET_REPLACEMENTORDERS:
            return {
                ...state,
                loadingReplacementorders: true,
                error: '',
                replacementOrders: [],
            };

        case MainActionTypes.DO_GET_REPLACEMENTORDERS_OK:
            return {
                ...state,
                loadingReplacementorders: false,
                replacementOrders: action.payload,
            };

        case MainActionTypes.DO_GET_REPLACEMENTORDERS_KO:
            return {
                ...state,
                loadingReplacementorders: false,
                error: action.payload,
                replacementOrders: [],
            };

        case MainActionTypes.DO_GET_FEATURE_OPTIONS:
            return {
                ...state,
                loading: true,
                error: '',
                featureOptions: { ...state.featureOptions },
            };

        case MainActionTypes.DO_GET_FEATURE_OPTIONS_OK:
            let featureOptions = _.cloneDeep(state.featureOptions);
            if (!featureOptions[action.payload.type]) {
                featureOptions[action.payload.type] = {};
            }
            if (action.payload.response) {
                featureOptions[action.payload.type][action.payload.feature] = [...action.payload.response];
                if (featureOptions['OTROSPRODUCTOS'] && featureOptions['OTROSPRODUCTOS']['CATEGORIA']) {
                    featureOptions = _.cloneDeep(featureOptions);
                    if (featureOptions['OTROSPRODUCTOS']['CATEGORIA'].filter((c) => c.value == '').length) {
                        featureOptions['OTROSPRODUCTOS']['CATEGORIA'].map((o) => {
                            if (o.value == '') {
                                o.label = 'search_input_category';
                            }
                            return o;
                        });
                    } else {
                        featureOptions['OTROSPRODUCTOS']['CATEGORIA'].unshift({
                            label: 'search_input_category',
                            value: '',
                        });
                    }
                }
            }
            return {
                ...state,
                loading: false,
                featureOptions,
            };

        case MainActionTypes.DO_GET_FEATURE_OPTIONS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                featureOptions: { ...state.featureOptions },
            };

        case MainActionTypes.DO_GET_FEATURE_CHECKS:
            return {
                ...state,
                loading: true,
                error: '',
            };

        case MainActionTypes.DO_GET_FEATURE_CHECKS_OK:
            return {
                ...state,
                loading: false,
                searchFeatureChecks: { ...action.payload.searchFeatureChecks },
            };

        case MainActionTypes.DO_GET_FEATURE_CHECKS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                searchFeatureChecks: { ...state.searchFeatureChecks },
            };
        case MainActionTypes.DO_RESET_FEATURE_CHECKS:
            return {
                ...state,
                searchFeatureChecks: SearchFeatureChecksHelper.default(),
            };
        case MainActionTypes.DO_GET_BANNERS:
            return {
                ...state,
                loading: true,
                error: '',
                banners: undefined,
            };

        case MainActionTypes.DO_GET_BANNERS_OK:
            return {
                ...state,
                loading: false,
                banners: action.payload,
            };

        case MainActionTypes.DO_GET_BANNERS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                banners: undefined,
            };

        case MainActionTypes.DO_SET_MENU_ITEM:
            return {
                ...state,
                menuItem: action.payload.menuItem,
            };

        case MainActionTypes.DO_SET_PRE_LOGIN_PARAMS:
            return {
                ...state,
                preLogin: { ...action.payload.preLogin },
            };

        case MainActionTypes.DO_SET_FORCE_SEARCH_TYPE_FLAG:
            // console.log(state, action);
            return {
                ...state,
                forceSearchTypeFlag: action.payload.forceSearchTypeFlag,
            };

        default:
            return state;
    }
}
